import { AddToPhotosOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { WithMoveToInventoryCatalogItem } from 'features/moveToInventoryCatalogItem';

interface MoveToInventoryCatalogItemButtonProps {
    isSingleItem?: boolean;
}

export const MoveToInventoryCatalogItemButton = memo(
    ({ isSingleItem }: MoveToInventoryCatalogItemButtonProps) => {
        const { t } = useTranslation();

        return (
            <WithMoveToInventoryCatalogItem isSingle={isSingleItem}>
                <Box
                    display="flex"
                    alignItems="center"
                    sx={(theme) => ({
                        gap: '4px',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: '#E8EEF6',
                        },
                        '& .MuiSvgIcon-root': {
                            color: theme.palette.primary.main,
                        },
                    })}
                >
                    <AddToPhotosOutlined
                        sx={{
                            fontSize: '20px',
                            width: '20px',
                            height: '20px',
                        }}
                    />
                    <Typography color="primary" typography="openSans.subtitle2">
                        {t('Add to Inventory')}
                    </Typography>
                </Box>
            </WithMoveToInventoryCatalogItem>
        );
    },
);
